let channel: BroadcastChannel | null = null;
const tabId = crypto.randomUUID();
const CHANNEL_NAME = "auth_channel";

function getChannel() {
  if (!channel) channel = new BroadcastChannel(CHANNEL_NAME);
  return channel;
}

export const broadcastLogin = () => {
  getChannel().postMessage({ type: "LOGIN", from: tabId });
};

export const broadcastLogout = () => {
  getChannel().postMessage({ type: "LOGOUT", from: tabId });
};

export const listenForAuthEvents = (
  onLogin: () => void,
  onLogout: () => void
) => {
  const ch = getChannel();
  const handler = (event: MessageEvent) => {
    const { type, from } = event.data || {};
    if (from === tabId) return;
    if (type === "LOGIN") onLogin();
    if (type === "LOGOUT") onLogout();
  };
  ch.addEventListener("message", handler);

  return () => ch.removeEventListener("message", handler);
};

window.addEventListener("beforeunload", () => {
  if (channel) {
    channel.close();
    channel = null;
  }
});
